import label from './scatter.label'
import itemStyle from './scatter.itemStyle'
import tooltip from './scatter.tooltip'

export default {
  name: "scatter",
  nickname: "散点图",
  desc: "scatter",
  type: "object",
  props: {
    name: {
      name: "name",
      nickname: "名称",
      desc:
        '系列名称，用于<a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip">tooltip</a>的显示，<a target="__blank" href="https://echarts.apache.org/zh/option.html#legend">legend</a> 的图例筛选，在 <code class="codespan">setOption</code> 更新数据和配置项时用于指定对应的系列。',
    },
    label,
    itemStyle,
    tooltip,
    type: {
      name: "type",
      nickname: "类型",
      desc: "type",
      value: "",
      defaultValue: "",
      type: "pureValue",
    },
  },
}
